import React, { useEffect, useState } from "react";
import image3 from "../../assest/GreenHome/images/Image3.jpeg";

const CompanyViewSection = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  // Update the scroll position state
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY); // Capture the vertical scroll position
    };

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 1500);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="relative min-h-screen text-center bg-inherit flex items-center justify-center ">
      <div className="relative w-full h-full flex items-center justify-center text-primary-light ">
        <div className="absolute inset-0 flex flex-col items-center justify-center h-4/5 bg-transparent z-20 ">
          <h2 className="text-6xl xl:text-8xl font-gilroy tracking-wide xl:tracking-widest mb-4">
            K2 ხედვა
          </h2>
          <p className="my-4 max-w-2xl text-lg tracking-wider font-semibold">
            ვქმნით და ვაშენებთ გარემოს, სადაც სიცოცხლეა, სადაც იბადება ახალი და
            მრავალფეროვანი ურთიერთობები.
          </p>
          {/* <a
            href="/company-view"
            className="relative uppercase text-lg font-bold tracking-wider  bg-transparent no-underline opacity-100 transform transition-all duration-[0.45s] ease-out delay-[0.6s] flex flex-col justify-center items-center whitespace-nowrap cursor-pointer group"
          >
            აღმოაჩინე მეტი
            <span className="absolute bottom-0 left-0 w-0 h-[2px]  transition-all duration-500 group-hover:w-full z-20"></span>
          </a> */}
        </div>
      </div>
      <div className="absolute w-full h-full inset-0 overflow-hidden bg-black z-[10]  ">
        <img
          src={image3}
          alt="Promo Background"
          className={`opacity-70 inline-block max-w-full w-full h-[calc(100vh)+250px] text-center align-middle`}
          style={
            isLargeScreen
              ? {
                  transform: `translateY(-${scrollY * 0.04}px)`,
                  transition: "transform 1s",
                  objectFit: "cover",
                }
              : {
                  height: "100vh", // Ensure it always covers the viewport height
                  objectFit: "cover",
                } // Ensures full coverage}
          }
        />
      </div>
    </section>
  );
};

export default CompanyViewSection;
// style={{
//   transform: `translateY(-${scrollY * 0.05}px)`,
//   transition: "transform 1s",
//   ...(isLargeScreen && {
//     // Add your styles for screens wider than 2490px here
//     filter: "brightness(1.2)",
//     transform: `translateY(-${scrollY * 0.05}px) scale(1.1)`,
//   }),
// }}
